import React, { useEffect, useState } from 'react';
import {
  Tabbed, Frame, Scene, Card, Line, Chip, Bar, Clock, Avatar, Spark, Wx, WeatherStrip,
  Stars, SunArc, Moon, Radar, Waveform, ScoreBand, Painting, ThrowDiagram, pos, COLORS,
} from './kit';

// Ambient Loop layouts: a day of slots, the six passive boards, the
// projection rooms (glass vs glow) and the schedule editor. Fixture data only.

/* ---- fixtures ------------------------------------------------------------ */
const DEPARTURES = [
  ['Tram 4', 'Central · platform B', '3 min', 'ok'],
  ['Bus 22', 'Harbour', '7 min', 'ok'],
  ['Tram 4', 'Central · platform B', '11 min', 'ok'],
  ['IC 812', 'Airport · platform 6', '08:05', 'ok'],
  ['Bus 9', 'University', '+4 late', 'warn'],
  ['Bike share', 'Dock 17 · 5 bikes', 'now', 'teal'],
];
const WX_HOURS = [['07', 'cloud', 12], ['08', 'cloud', 13], ['09', 'sun', 14], ['10', 'sun', 15], ['11', 'sun', 16], ['12', 'cloud', 16], ['13', 'cloud', 16], ['14', 'rain', 15], ['15', 'rain', 14], ['16', 'rain', 14]];
const CAL = [['09:00', 'Team check-in', 'Meet · 30 min'], ['10:30', 'Project review · Q4 launch', 'Room 2 · 4 people'], ['12:30', 'Lunch · Dana', 'Osteria · booked'], ['15:30', 'School pickup', 'Mia · 15 min drive'], ['19:00', 'Plan dinner', 'home · salmon']];
const GATES = [
  ['INV-20841', 'Acme Industrial · $12,480', 'over $10,000 · 2 min', 'warn'],
  ['PO-7731 change', 'quantity 40 → 48 · $1,920', 'route for approval · 18 min', ''],
  ['Supplier onboarding', 'Nordic Fasteners · W-9 verified', 'sign-off · 1 h', ''],
];
const PIPELINES = [
  ['Invoice intake', 'review gate', 0.62, '38 runs', COLORS.amber],
  ['Supplier onboarding', 'validate', 0.35, '4 runs', COLORS.teal],
  ['Weekly digest', 'done 08:10', 1, '1 run', COLORS.green],
  ['Launch swarm', 'assemble · refine 2/2', 0.78, '2 runs', COLORS.violet],
  ['Ticket triage', 'classify', 0.5, '112 runs', COLORS.teal],
  ['Price watch', 'scheduled · 14:00', 0.08, '—', COLORS.muted],
];
const DELIVERIES = [['DHL', 'Monitor arm', 'today · 14–16', 'ok'], ['UPS', 'Spare filters ×3', 'today · by 18:00', 'ok'], ['Post', 'Letter · council', 'tomorrow', '']];
const MEALS = [['Mon', 'Lentil soup'], ['Tue', 'Salmon · greens'], ['Wed', 'Pasta night'], ['Thu', 'Leftovers'], ['Fri', 'Pizza · kids pick'], ['Sat', 'Out · Osteria'], ['Sun', 'Roast']];
const CHORES = [['Bins out', 'Tue evening', 'Sam', 1], ['Water tomatoes', 'daily · done', 'Mia', 2], ['Dentist booking', 'this week', 'Alex', 0], ['Return parcel', 'by Friday', 'Sam', 1]];
const WHO = [['Alex', 'office · back 17:40', 0], ['Sam', 'home', 1], ['Mia', 'school · pickup 15:30', 2], ['Grandma', 'called 2 h ago', 3]];
const NEWS = [
  ['12:04', 'Nordic steel prices ease for a third week', 'Reuters', 'supplier-onboarding'],
  ['11:48', 'EU customs pilots single-window filing from Q1', 'FT', 'invoice-intake'],
  ['11:20', 'Grid operator confirms winter capacity margin', 'Bloomberg', 'interest · energy'],
  ['10:55', 'City extends tram line 4 to the harbour by 2028', 'Local', 'interest · city'],
  ['10:12', 'Weekend: coastal path reopens after repairs', 'Local', 'interest · outdoors'],
  ['09:40', 'Freight index flat; Baltic surcharges unchanged', 'Lloyd’s List', 'invoice-intake'],
  ['09:05', 'Rain clears by evening; frost likely overnight', 'Met service', 'interest · garden'],
];
const SHOPPING = [['Milk · oat', 1], ['Salmon · 4 fillets', 1], ['Greens', 0], ['Dishwasher tabs', 0], ['Mia · swim goggles', 0], ['Coffee beans', 0]];
const TICKERS = [['STEEL', '612.40', '−1.8%', 'danger', [9, 8, 8, 7, 7, 6, 6]], ['EUR/USD', '1.0842', '+0.2%', 'ok', [4, 5, 5, 6, 6, 7, 7]], ['BRENT', '78.12', '−0.6%', 'danger', [8, 8, 7, 8, 7, 7, 6]], ['NVDA', '1,184', '+1.1%', 'ok', [3, 4, 4, 5, 6, 6, 7]]];
const PACK = [['Passport · ID', 1], ['Chargers · adapter EU', 1], ['Rain shell', 1], ['Running shoes', 0], ['Gifts for Ana', 0], ['Camera · 2 cards', 0]];

/* ---- small shared pieces -------------------------------------------------- */
function GateCard({ style, light, posted }) {
  return (
    <div className={`as-gatecard ${light ? 'light' : ''} ${posted ? 'posted' : ''}`} style={style}>
      <span className="as-gatecard-k">{posted ? 'Committed · 09:41' : 'Gate waiting · high'}</span>
      <strong>INV-20841 · Acme Industrial · $12,480</strong>
      <span>{posted ? 'posted to ERP by the runtime · receipt in ledger' : 'over $10,000 · PO-7731 matched 98% · 2 min ago'}</span>
      <span className="as-gatecard-cta">{posted ? 'cm_8f3a21 · approvals-v7' : light ? 'Review on your phone →' : 'Tap to review →'}</span>
    </div>
  );
}
export { GateCard };

function Departures({ rows = DEPARTURES, n = 6 }) {
  return rows.slice(0, n).map(([a, b, c, t]) => <Line key={a + b + c} a={a} b={b} c={c} tone={t} />);
}

function Pipelines() {
  return PIPELINES.map(([a, b, v, c, col]) => (
    <div key={a} className="as-pipe">
      <Line a={a} b={b} c={c} />
      <Bar v={v} color={col} />
    </div>
  ));
}

function Household({ full }) {
  return (
    <>
      <Card title="Meals this week" right="Sat: table booked 19:30">
        {MEALS.map(([d, m]) => <Line key={d} a={d} b={m} on={d === 'Tue'} />)}
      </Card>
      <Card title="Parcels" right="2 arriving">
        {DELIVERIES.map(([a, b, c, t]) => <Line key={b} a={b} b={a} c={c} tone={t} />)}
        {full && <Line a="Return" b="Zara · label printed" c="drop by Fri" />}
      </Card>
      <Card title="Chores" right="3 open">
        {CHORES.map(([a, b, who, i]) => <Line key={a} lead={<Avatar name={who} i={i} />} a={a} b={b} c={who} />)}
      </Card>
      <Card title="Who is where">
        {WHO.map(([a, b, i]) => <Line key={a} lead={<Avatar name={a} i={i} />} a={a} b={b} />)}
        {full && <div className="as-fridge"><span className="as-h">Fridge</span><Chip tone="warn">milk low</Chip><Chip>eggs 4</Chip><Chip>salmon · tonight</Chip></div>}
      </Card>
      {full && (
        <>
          <Card title="Shopping" right="2 of 6 · Sam at the shop 17:10">
            {SHOPPING.map(([a, done]) => <Line key={a} lead={<span className={`as-check ${done ? 'on' : ''}`} />} a={a} c={done ? 'in basket' : ''} tone="ok" />)}
          </Card>
          <Card title="Family notes" right="3">
            <Line lead={<Avatar name="Mia" i={2} />} a="Swim kit Thursday" b="pinned by Sam" />
            <Line lead={<Avatar name="Alex" i={0} />} a="Back 17:40 · bring the parcel in" b="today" />
            <Line lead={<Avatar name="Grandma" i={3} />} a="Sunday roast at hers?" b="reply by Fri" c="open" tone="teal" />
          </Card>
          <Card title="Home" right="all quiet">
            <Line a="Heating" b="21° living · schedule eco at 22:00" c="on" tone="teal" /><Line a="Front door" b="locked 08:12 · Alex" c="locked" tone="ok" /><Line a="Lights" b="kitchen 40% · hall off" c="2 on" /><Line a="Washing" b="cycle ends 15:52" c="38 min" />
          </Card>
          <Card title="Tonight" right="3 items">
            <Line a="19:00" b="Dinner · salmon · greens" /><Line a="20:00" b="Mia · reading · 20 min" /><Line a="20:30" b="Film on request · phone to pause" c="beam" tone="teal" />
          </Card>
        </>
      )}
    </>
  );
}

/* ---- slot layouts --------------------------------------------------------- */
function Waking() {
  return (
    <Frame kind="ceiling" scene="dawn" source="lamp" label="bulb · bedside lamp · ceiling">
      <div className="as-ceiling-copy">
        <Clock time="05:50" date="Tue 14 Oct · brightening to 06:30" size={56} />
        <p className="as-firstline">Team check-in 09:00 · leave 08:05 for the airport train</p>
        <div className="as-ceiling-row">
          <span><Wx k="cloud" /> 12° now · 16° · rain after 15:00</span>
          <span>slept 7 h 12 · 2 wakes · HR 54</span>
        </div>
        <p className="as-fading">Tomorrow: 14° · showers · Mia swim kit</p>
      </div>
    </Frame>
  );
}

function Morning() {
  return (
    <Frame kind="panel" scene={null} label="wall panel · 27in · kitchen">
      <div className="as-split2">
        <div className="as-pane">
          <Scene name="ocean" />
          <Clock className="as-pane-clock" time="06:42" date="Tuesday 14 October · sunrise 07:31" size={54} />
          <GateCard style={{ position: 'absolute', right: 14, bottom: 14, width: 300 }} />
        </div>
        <div className="as-col">
          <Card title="Departures" right="Harbour stop · 4 min walk"><Departures /></Card>
          <Card title="Weather" right={<><Wx k="rain" /> 16° · rain after 15:00 · take the shell</>}><WeatherStrip hours={WX_HOURS} /></Card>
          <Card title="Commute" right="leave 08:05">
            <Line a="Tram 4 → IC 812" b="22 min · platform 6" c="08:31" tone="teal" />
            <Line a="Drive" b="A2 · roadworks at junction 4" c="37 min" tone="warn" />
          </Card>
          <Card title="Today" right="5 items">{CAL.map(([t, a, b]) => <Line key={t} a={a} b={b} c={t} />)}</Card>
        </div>
      </div>
      <div className="as-base">
        <Chip tone="teal">Family · 2 reminders</Chip>
        <Chip>Pick up parcel · Post · until 17:00</Chip>
        <Chip>Air 42 · good</Chip>
        <Chip>Pollen · low</Chip>
        <span className="as-base-note">Mia: swim kit Thursday · Alex back 17:40</span>
      </div>
    </Frame>
  );
}

function Working() {
  return (
    <Frame kind="panel" label="wall panel · studio · work surface 09:00–12:30">
      <div className="as-topband">
        <strong>Work surface</strong><span className="as-dim">Acme Ops · Operations workspace</span>
        <span className="as-spacer" />
        <Chip tone="warn">3 gates waiting</Chip><Chip>7 pipelines live</Chip><span className="as-dim">09:14</span>
      </div>
      <div className="as-grid3">
        <Card title="Pipelines" right="runs today 157"><Pipelines /></Card>
        <Card title="Pending gates" right="oldest 1 h">
          {GATES.map(([a, b, c, t]) => <Line key={a} a={a} b={b} c={c} tone={t} />)}
          <div className="as-btnrow"><span className="as-btn primary">Review INV-20841</span><span className="as-btn">All gates</span></div>
        </Card>
        <Card title="Athena · today" right="vs yesterday">
          <div className="as-kpis">
            <div><span className="as-h">Runs</span><strong>312</strong><Spark points={[22, 31, 28, 40, 44, 39, 52]} /></div>
            <div><span className="as-h">Error rate</span><strong>1.8%</strong><Spark points={[4, 3, 3, 2, 2, 2, 2]} color={COLORS.amber} /></div>
            <div><span className="as-h">Gated commits</span><strong>41</strong><Spark points={[3, 5, 4, 7, 6, 8, 8]} color={COLORS.green} /></div>
            <div><span className="as-h">p95 duration</span><strong>35.1 s</strong><Spark points={[6, 6, 5, 5, 5, 4, 4]} color={COLORS.violet} /></div>
          </div>
        </Card>
        <Card title="Deliveries" right="3 arriving · 1 outbound">
          {DELIVERIES.map(([a, b, c, t]) => <Line key={b} a={b} b={a} c={c} tone={t} />)}
          <Line a="Prototype PCBs" b="Courier · signed by reception" c="11:20" tone="teal" />
          <Line a="Return · Zara" b="label printed · drop-off" c="by Fri" />
          <Line a="SH-3301" b="outbound · customs Rotterdam" c="in transit" />
        </Card>
        <Card title="Document intake" right="inbox · 6 new">
          <Line a="INV-20841.pdf" b="Acme · 184 KB · extracted" c="gate" tone="warn" />
          <Line a="INV-20840.pdf" b="Baltic Freight · 96 KB" c="posted 08:52" tone="ok" />
          <Line a="PO-7731-rev2.pdf" b="quantity change" c="matching" tone="teal" />
          <Line a="W-9 Nordic.pdf" b="supplier onboarding" c="verified" tone="ok" />
          <Line a="contract-2026.docx" b="legal · 2 clauses flagged" c="review" tone="warn" />
          <Line a="receipts ×3" b="expenses · OCR 0.97" c="filed" tone="ok" />
        </Card>
        <Card title="Releases" right="Dev Console">
          <Line a="prod" b="v1.42 · healthy · 14 d" c="● ok" tone="ok" />
          <Line a="UAT" b="v1.43 · 2 PRs in review" c="promote?" tone="teal" />
          <Line a="preview" b="pr-218 · expires in 2 h" c="open" />
          <Line a="Assurance" b="HTTP 42/42 · browser 12/12" c="green" tone="ok" />
          <Line a="Workers" b="2 up · queue 0 · p95 35.1 s" c="ok" tone="ok" />
          <Line a="Cost today" b="API $2.10 · workers $1.70 · GPU 0" c="$3.80" />
        </Card>
      </div>
    </Frame>
  );
}

function Midday() {
  return (
    <Frame kind="panel" label="wall panel · midday timeline">
      <div className="as-split2 wide">
        <div className="as-pane">
          <Scene name="fjord" />
          <div className="as-slowtv"><span className="as-slowtv-tag">slow TV</span>Bergen → Oslo · 4 h 12 left · Myrdal next</div>
          <ScoreBand />
        </div>
        <div className="as-col">
          <Card title="Timeline" right="filtered · 2 workflows · 3 interests">
            <div className="as-timeline">
              {NEWS.map(([t, h, s, tag]) => (
                <div key={t} className="as-tl-item">
                  <span className="as-tl-t">{t}</span>
                  <div><strong>{h}</strong><span className="as-dim">{s} · <em>{tag}</em></span></div>
                </div>
              ))}
            </div>
            <span className="as-dim">muted: politics · celebrity · 14 items hidden today</span>
          </Card>
          <Card title="Markets" right="watchlist">
            <div className="as-tickers">
              {TICKERS.map(([s, v, d, t, p]) => <div key={s}><span className="as-h">{s}</span><strong>{v}</strong><Chip tone={t}>{d}</Chip><Spark points={p} color={t === 'ok' ? COLORS.green : COLORS.red} width={60} /></div>)}
            </div>
          </Card>
        </div>
      </div>
    </Frame>
  );
}

function Afternoon() {
  return (
    <Frame kind="panel" label="wall panel · household board 15:00">
      <div className="as-topband">
        <strong>Household</strong><span className="as-dim">Tuesday · 14:48</span>
        <span className="as-spacer" />
        <Chip tone="teal">School pickup in 42 min</Chip><Chip>Grandma called 2 h ago</Chip><Chip><Wx k="rain" /> 14° · rain</Chip>
      </div>
      <div className="as-grid4"><Household full /></div>
    </Frame>
  );
}

export function EveningLayout({ glow }) {
  return (
    <Frame kind={glow ? 'glow' : 'panel'} scene="dusk" source={glow ? 'beam' : null} label={glow ? 'beam · credenza · 3 m wall' : 'wall panel · glass variant'}>
      <div className={`as-evening ${glow ? 'light' : ''}`}>
        <Clock className="as-evening-clock" time="18:36" date="sunset 18:42 · 15° · clearing" size={64} />
        <div className="as-evening-col">
          <span className="as-h">Timeline</span>
          <Line a="17:52" b="Shipment SH-3301 cleared customs · Rotterdam" c="done" tone="ok" />
          <Line a="now" b="2 gates waiting · INV-20841 · PO-7731" c="review" tone="warn" />
          <Line a="18:42" b="Sunset · west window" />
          <Line a="19:00" b="Dinner · salmon · greens" />
          <Line a="20:30" b="Film on request · phone to pause" />
          <Line a="22:30" b="Night sky on the ceiling" />
        </div>
        <div className="as-evening-base">
          <ScoreBand light={glow} />
          <div className="as-music"><Waveform w={180} h={18} /><span>Nils Frahm · Says · quiet</span></div>
        </div>
      </div>
    </Frame>
  );
}

export function NightCeiling({ glow = true }) {
  return (
    <Frame kind="ceiling" scene="night" source="lamp" label="bulb · bedside lamp · ceiling">
      <Stars />
      <div className="as-night">
        <div className="as-night-moon"><Moon /><div><strong>Waxing gibbous · 82%</strong><span className="as-dim">moonrise 16:10 · sets 03:48</span></div></div>
        <div className="as-night-sleep">
          <span className="as-h">Sleep arc</span>
          <div className="as-sleeparc"><span style={{ width: '12%' }} /><span className="deep" style={{ width: '28%' }} /><span style={{ width: '18%' }} /><span className="deep" style={{ width: '22%' }} /><span className="rem" style={{ width: '20%' }} /></div>
          <div className="as-row"><span>22:30</span><span>lights out · dim to 2% · wake 06:30</span><span>06:30</span></div>
        </div>
        <p className="as-dimline">06:30 · Team check-in 09:00 · leave 08:05 · 12° cloud · bins out</p>
      </div>
    </Frame>
  );
}

function Spare() {
  const loops = ['gallery', 'generative', 'hearth', 'rain', 'reef', 'garden', 'clouds', 'clock'];
  return (
    <Frame kind="panel" scene="gallery" label="wall panel · spare moment · aesthetic mode">
      <Painting style={pos(70, 56, 520, 350)} />
      <div className="as-gallery-cap">
        <strong>Katsushika Hokusai</strong><span>Under the Wave off Kanagawa · c. 1831 · woodblock print</span>
        <span className="as-dim">rotates every 20 min · dims with room light · 1,204 works in the library</span>
      </div>
      <Clock className="as-gallery-clock" time="16:05" date="Tuesday · 15° · clearing" size={64} />
      <div className="as-loops">
        {loops.map((l) => <Chip key={l} tone={l === 'gallery' ? 'teal' : ''}>{l}</Chip>)}
        <span className="as-dim">next: generative · in 14 min · agent suggests reef for the kids at 17:00</span>
      </div>
      <Card title="Library" right="cached 6.2 GB · offline ok" style={pos(632, 262, 360, 220)}>
        <Line a="Paintings" b="public-domain set · 1,204 works" c="licensed" tone="ok" />
        <Line a="Nature loops" b="ocean · forest · reef · 4K · 38 h" c="licensed" tone="ok" />
        <Line a="Family photos" b="212 · Sam’s album · shown weekends" c="yours" />
        <Line a="Generative" b="ink forms · rendered on device" c="never repeats" />
        <Line a="Room light" b="38 lux → brightness 22% · warm" c="auto" tone="teal" />
        <Line a="Presence" b="empty 6 min → dim to scene at 10" c="4 min" />
      </Card>
    </Frame>
  );
}

const DAY_TABS = [
  { id: 'waking', label: 'Waking', sub: '05:50 · ceiling', note: 'Bulb in the bedside lamp. Dawn gradient brightens on schedule; the first line of the day and tomorrow fading out.' },
  { id: 'morning', label: 'Morning', sub: '06:30 · 2-pane', note: 'Wall panel in the kitchen. Departures, weather, commute and calendar beside the loop; a waiting gate pulls forward as a card.' },
  { id: 'working', label: 'Working', sub: '09:00 · card grid', note: 'Studio panel. Pipelines, gates, Athena, intake and releases — one glance, never a wall of tiles.' },
  { id: 'midday', label: 'Midday', sub: '12:30 · timeline', note: 'Slow TV with the live score in a band; news filtered by two live workflows and three interests.' },
  { id: 'afternoon', label: 'Afternoon', sub: '15:00 · household', note: 'Meals, parcels, chores and who-is-where with avatars instead of names.' },
  { id: 'evening', label: 'Evening', sub: '18:00 · full-bleed', note: 'Beam on the credenza — glow layout, light on a dark room: the ocean loop with one timeline column.' },
  { id: 'night', label: 'Night', sub: '22:30 · ceiling', note: "Bulb pointed up: tonight's real sky, the sleep arc and one dim line for the morning." },
  { id: 'spare', label: 'Spare moment', sub: 'aesthetic', note: 'Beauty over density. Eight loops; agents suggest, the household decides.' },
];

export function AmbientDay({ frame }) {
  return (
    <Tabbed frame={frame} tabs={DAY_TABS} start={1} interval={4200}>
      {(tab) => ({
        waking: <Waking />, morning: <Morning />, working: <Working />, midday: <Midday />,
        afternoon: <Afternoon />, evening: <EveningLayout glow />, night: <NightCeiling />, spare: <Spare />,
      })[tab.id]}
    </Tabbed>
  );
}

/* ---- the six boards -------------------------------------------------------- */
function MapPane() {
  return (
    <div className="as-pane as-map">
      <svg viewBox="0 0 600 540" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <defs><pattern id="as-map-grid" width="40" height="40" patternUnits="userSpaceOnUse"><path d="M40 0H0V40" fill="none" stroke="rgba(255,255,255,0.05)" /></pattern></defs>
        <rect width="600" height="540" fill="url(#as-map-grid)" />
        <path d="M-20 420 C 120 380, 200 470, 330 430 S 520 380, 640 410 L640 560 L-20 560z" fill="rgba(79,140,255,0.12)" />
        <g stroke="rgba(255,255,255,0.18)" strokeWidth="6" fill="none" strokeLinecap="round">
          <path d="M60 40 L 240 260 L 330 300 L 560 280" /><path d="M20 300 C 150 280, 220 240, 240 260" /><path d="M330 300 L 300 520" /><path d="M420 20 L 380 240 L 330 300" />
        </g>
        <g stroke="rgba(20,224,200,0.9)" strokeWidth="3" fill="none" strokeDasharray="8 6"><path d="M240 260 L 330 300 L 560 280" /></g>
        <circle cx="240" cy="260" r="8" fill="#14e0c8" /><circle cx="240" cy="260" r="16" fill="rgba(20,224,200,0.25)" />
        <circle cx="560" cy="280" r="6" fill="#fff" />
        <text x="252" y="250" className="as-map-label">home</text><text x="520" y="268" className="as-map-label">Harbour stop</text>
      </svg>
      <div className="as-map-advice"><strong>Leave now</strong><span>Tram 4 in 3 min · walk 4 min · arrive Central 08:31 · one change</span></div>
    </div>
  );
}

function BoardDepartures() {
  return (
    <div className="as-split2 map">
      <MapPane />
      <div className="as-col">
        <Card title="Departures" right="Harbour stop · live">
          <Departures />
          <Line a="Tram 4" b="Central · platform B" c="19 min" />
          <Line a="Ferry F2" b="Island · pier 3 · every 30" c="08:15" />
        </Card>
        <Card title="Disruptions" right="1 · 2 notes">
          <Line a="Bus 9" b="roadworks · Kingsway · diverted via Park Rd" c="+4 min" tone="warn" />
          <Line a="IC 812" b="on time · platform 6 · 8 coaches · quiet coach 3" c="08:05" tone="ok" />
          <Line a="Tram 4" b="crowded 07:30–08:15 · bikes not allowed" c="info" />
        </Card>
        <Card title="Finish the coffee?" right="decision">
          <Line a="Yes" b="Tram 4 at 06:53 · arrive 08:41" c="+10 min" />
          <Line a="No" b="leave now · arrive 08:31" c="recommended" tone="teal" />
          <Line a="At the stop" b="12° · dry until 14:50 · shelter" c="ok" tone="ok" />
        </Card>
      </div>
    </div>
  );
}

function BoardHousehold() {
  return (
    <>
      <div className="as-topband"><strong>Household</strong><span className="as-dim">Tuesday 14:48</span><span className="as-spacer" /><Chip tone="teal">pickup in 42 min</Chip><Chip>Grandma called 2 h ago</Chip></div>
      <div className="as-grid4"><Household full /></div>
    </>
  );
}

function BoardSky() {
  return (
    <div className="as-split2 rev">
      <div className="as-col">
        <Card title="Next hours" right={<><Wx k="rain" /> rain from 14:50</>}>
          <WeatherStrip hours={WX_HOURS} />
          <span className="as-h" style={{ marginTop: 6 }}>Week</span>
          <WeatherStrip hours={[['Wed', 'rain', 14], ['Thu', 'cloud', 13], ['Fri', 'sun', 15], ['Sat', 'sun', 17], ['Sun', 'cloud', 16], ['Mon', 'rain', 12], ['Tue', 'cloud', 13]]} />
        </Card>
        <div className="as-grid2">
          <Card title="Rain radar" right="15 km"><Radar w={226} h={118} /></Card>
          <Card title="Sun" right="day 11 h 11"><SunArc w={226} h={78} now={0.52} /><div className="as-row as-dim"><span>UV 3 · moderate</span><span>golden hour 18:05</span></div></Card>
        </div>
        <Card title="Tonight" right="advice">
          <Line lead={<Moon size={22} />} a="Frost −1° at 04:00" b="clear after midnight · wind 6 km/h" c="cover the tomatoes" tone="warn" />
          <Line a="Sprinklers" b="skip tomorrow · rain covers it" c="auto" tone="teal" />
          <Line a="Air" b="42 · good · pollen low · humidity 71%" c="ok" tone="ok" />
        </Card>
      </div>
      <div className="as-pane">
        <Scene name="garden" />
        <div className="as-garden">
          <span className="as-h light">Garden</span>
          {[['Tomatoes · bed 1', 0.62, 'water tonight'], ['Herbs · pots', 0.81, 'ok'], ['Lawn', 0.44, 'rain will cover it'], ['Apple tree', 0.7, 'harvest in 9 days']].map(([a, v, c]) => (
            <div key={a} className="as-pipe light"><Line a={a} c={c} /><Bar v={v} color="#9ad68d" /></div>
          ))}
          <div className="as-row light"><span>soil 14° · pollen low · birds: 3 species this morning</span></div>
        </div>
      </div>
    </div>
  );
}

function BoardMarkets() {
  return (
    <div className="as-split2 wide">
      <div className="as-pane">
        <Scene name="art" />
        <div className="as-headlines">
          {NEWS.slice(0, 3).map(([t, h, s, tag]) => <div key={t}><strong>{h}</strong><span>{s} · {t} · <em>{tag}</em></span></div>)}
        </div>
        <div className="as-filterchip"><Chip tone="teal">filtered by</Chip><Chip>supplier-onboarding</Chip><Chip>invoice-intake</Chip><Chip>energy</Chip></div>
      </div>
      <div className="as-col">
        <Card title="Watchlist" right="15 min delay">
          {TICKERS.map(([s, v, d, t, p]) => <Line key={s} lead={<Spark points={p} color={t === 'ok' ? COLORS.green : COLORS.red} width={56} height={16} />} a={s} b={v} c={d} tone={t} />)}
          <Line lead={<Spark points={[5, 5, 6, 6, 6, 7, 7]} color={COLORS.green} width={56} height={16} />} a="ALU" b="2,418" c="+0.4%" tone="ok" />
          <Line lead={<Spark points={[7, 6, 6, 5, 5, 5, 4]} color={COLORS.red} width={56} height={16} />} a="FREIGHT" b="1,142" c="−0.9%" tone="danger" />
        </Card>
        <Card title="Why these" right="agent · explainable">
          <Line a="STEEL" b="3 open supplier quotes reference HRC index" />
          <Line a="EUR/USD" b="2 invoices in EUR due this week" />
          <Line a="BRENT" b="freight surcharge clause · Baltic Freight" />
          <Line a="ALU" b="Nordic Fasteners quote · onboarding" />
          <Line a="NVDA" b="your interest · tech" c="personal" />
        </Card>
      </div>
    </div>
  );
}

function BoardTravel() {
  return (
    <div className="as-split2 rev">
      <div className="as-col">
        <Card title="Lisbon" right="in 3 days · Fri 17 Oct">
          <div className="as-flight">
            <div><strong>FRA</strong><span>09:40</span></div>
            <div className="as-flight-mid"><span className="as-dim">LH 1172 · 3 h 05 · seat 14C</span><Bar v={0} /><span className="as-dim">gate opens 08:55 · bag drop 2</span></div>
            <div><strong>LIS</strong><span>11:45</span></div>
          </div>
          <Line a="Return" b="Tue 21 Oct · LH 1175 · 18:10 → 22:05" c="booked" tone="ok" />
          <Line a="Transfer" b="Metro red line · 25 min · hotel check-in from 15:00" />
        </Card>
        <Card title="Packing" right="3 of 6">
          {PACK.map(([a, done]) => <Line key={a} lead={<span className={`as-check ${done ? 'on' : ''}`} />} a={a} c={done ? 'packed' : ''} tone="ok" />)}
        </Card>
        <Card title="Documents" right="ok">
          <Line a="Passport" b="valid to 2031" c="ok" tone="ok" /><Line a="Hotel" b="Baixa · 3 nights · paid" c="ok" tone="ok" /><Line a="Travel insurance" b="renews Dec" c="ok" tone="ok" />
          <Line a="Boarding passes" b="issued 24 h before · to the phone" c="Thu 09:40" />
        </Card>
      </div>
      <div className="as-pane">
        <Scene name="lisbon" />
        <div className="as-dest">
          <Clock time="3 days" date="to departure · 71 h" size={44} />
          <div className="as-dest-wx">{[['Fri', 'sun', 24], ['Sat', 'sun', 25], ['Sun', 'cloud', 22], ['Mon', 'sun', 23], ['Tue', 'rain', 20]].map(([d, k, t]) => <div key={d}><span>{d}</span><Wx k={k} /><strong>{t}°</strong></div>)}</div>
          <span className="as-dim light">sunset 19:52 · 11° warmer than home · 1 h behind</span>
        </div>
      </div>
    </div>
  );
}

function BoardHealth() {
  const today = [2, 2, 1, 1, 1, 2, 4, 6, 5, 3, 3, 3, 4, 3, 3, 3, 5, 7, 8, 7, 5, 4, 3, 2];
  const yday = [2, 2, 2, 1, 1, 2, 3, 5, 6, 4, 3, 3, 3, 3, 4, 3, 4, 6, 9, 8, 6, 4, 3, 2];
  return (
    <div className="as-split2 rev">
      <div className="as-col">
        <Card title="Air · indoors" right="good">
          <div className="as-kpis three">
            <div><span className="as-h">CO₂</span><strong>612</strong><span className="as-dim">ppm · open a window at 1,000</span></div>
            <div><span className="as-h">PM2.5</span><strong>4</strong><span className="as-dim">µg/m³ · outdoors 9</span></div>
            <div><span className="as-h">Humidity</span><strong>48%</strong><span className="as-dim">21.5° living · 19° bedroom</span></div>
          </div>
          <Line a="Bedroom" b="CO₂ 540 · 19° · window cracked" c="good" tone="ok" />
          <Line a="Kitchen" b="PM2.5 spiked 18:40 · cooking · cleared" c="good" tone="ok" />
        </Card>
        <Card title="Energy · today vs yesterday" right="14.2 kWh · −8%">
          <div className="as-energy">{today.map((v, i) => <div key={i}><span style={{ height: yday[i] * 6 }} className="y" /><span style={{ height: v * 6 }} /></div>)}</div>
          <div className="as-row as-dim"><span>00</span><span>solar 6.1 kWh · export 1.8</span><span>23</span></div>
        </Card>
        <Card title="Water" right="184 L">
          <Line a="Shower" b="2 × 7 min" c="96 L" /><Line a="Garden" b="tonight · scheduled" c="~40 L" tone="teal" />
          <Line a="Dishwasher" b="eco · 19:30" c="12 L" /><Line a="Leak check" b="night flow 0 L/h" c="ok" tone="ok" />
        </Card>
      </div>
      <div className="as-pane">
        <Scene name="living" />
        <div className="as-human">
          <span className="as-h light">The human line</span>
          <strong>Grandma called 2 h ago</strong>
          <span>Mia · 6,412 steps · swim Thursday</span>
          <span>Alex · back 17:40 · Sam · home</span>
          <span className="as-dim light">quiet hours 22:00–07:00 · no notifications on glass</span>
        </div>
      </div>
    </div>
  );
}

const BOARDS = [
  { id: 'departures', label: 'Departures', sub: 'leave now?', C: BoardDepartures, note: 'A departures board over a soft map answers one question: leave now or finish the coffee.' },
  { id: 'household', label: 'Household', sub: 'one glance', C: BoardHousehold, note: 'Meals, parcels, chores and who-is-where, avatars instead of names; the fridge line is the only inventory.' },
  { id: 'sky', label: 'Sky and garden', sub: 'advice', C: BoardSky, note: 'Weather turned into advice — frost tonight, cover the tomatoes — with radar, sun arc, moon and bed moisture.' },
  { id: 'markets', label: 'Markets and news', sub: 'filtered', C: BoardMarkets, note: 'Three headlines over an artwork, four sparklines, and why each line is there — tied to live workflows.' },
  { id: 'travel', label: 'Travel countdown', sub: '3 days', C: BoardTravel, note: 'Flight, packing, documents and the destination light in one board.' },
  { id: 'health', label: 'Health and home', sub: 'air · energy', C: BoardHealth, note: 'Air, energy today against yesterday, water — and the small human line.' },
];

export function AmbientBoards({ frame }) {
  return (
    <Tabbed frame={frame} tabs={BOARDS} start={2} interval={4400} h={690}>
      {(tab, _i, select) => (
        <>
          <Frame kind="panel" label={`wall panel · ${tab.label.toLowerCase()} board`} style={{ height: 585 }}>
            <tab.C />
          </Frame>
          <div className="as-thumbs" style={pos(0, 598, 1040, 92)}>
            {BOARDS.map((b, k) => (
              <button key={b.id} type="button" className={`as-thumb ${b.id === tab.id ? 'on' : ''}`} onClick={() => select(k)} aria-label={`show the ${b.label} board`} aria-pressed={b.id === tab.id}>
                <div className="as-thumb-in"><div className="as-thumb-scale"><Frame kind="panel"><b.C /></Frame></div></div>
                <span>{b.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </Tabbed>
  );
}

/* ---- projection rooms ----------------------------------------------------- */
export function DiningLayout({ glow }) {
  return (
    <Frame kind={glow ? 'glow' : 'panel'} scene="mist" source={glow ? 'pendant' : null} label={glow ? 'bulb · pendant · 1.8 m wall' : 'wall panel · glass variant'}>
      <div className={`as-dining ${glow ? 'light' : ''}`}>
        <Clock time="18:52" date="Tuesday · dinner at 19:00" size={56} />
        <div className="as-dining-base">
          <div><span className="as-h">Tomorrow</span><strong><Wx k="rain" /> 14° · showers</strong><span>umbrella · Mia swim kit</span></div>
          <div><span className="as-h">08:05</span><strong>IC 812 · platform 6</strong><span>on time · leave 07:40</span></div>
          <div><span className="as-h">Dinner</span><strong>Salmon · greens</strong><span>table set · Alex 17:40 ✓</span></div>
          <div><span className="as-h">One gate</span><strong>INV-20841 · $12,480</strong><span>review on your phone</span></div>
        </div>
      </div>
    </Frame>
  );
}

export function StudioWall({ glow }) {
  return (
    <Frame kind={glow ? 'glow' : 'panel'} scene={null} source={glow ? 'mount' : null} label={glow ? 'beam · ceiling mount · studio wall' : 'wall panel · glass variant'}>
      <div className={`as-split2 ${glow ? 'light' : ''}`}>
        <div className="as-pane"><Scene name="ocean" /><Clock className="as-pane-clock" time="09:14" date="Tuesday 14 October · Acme Ops" size={48} /></div>
        <div className="as-col">
          <Card title="Pipelines" right="7 running · 1 gate waiting">
            <Line a="Invoice intake" b="review gate · INV-20841" c="Review" tone="teal" />
            <Line a="Supplier onboarding" b="validate" c="4 runs" /><Line a="Ticket triage" b="classify" c="112 runs" />
          </Card>
          <Card title="Athena · runs this week" right="1,284 · +12%"><Spark points={[120, 150, 170, 160, 210, 230, 244]} width={330} height={40} /></Card>
          <Card title="Deliveries" right="3 arriving today"><Line a="DHL" b="monitor arm" c="14–16" /><Line a="UPS" b="spare filters ×3" c="by 18:00" /><Line a="Courier" b="prototype PCBs" c="11:20" tone="teal" /></Card>
          <Card title="Studio" right="lunch order closes 11:30">
            <Line a="UAT v1.43" b="2 PRs in review" c="promote?" tone="teal" /><Line a="Room 2" b="Project review 10:30" c="4 people" />
          </Card>
        </div>
      </div>
    </Frame>
  );
}

const ROOMS = [
  { id: 'living', label: 'Living room', sub: 'beam · evening', throw: 'beam', note: 'Beam on the credenza throws up and back onto the wall above it: the ocean loop with one timeline column; the live score in a thin band.' },
  { id: 'dining', label: 'Dining', sub: 'bulb · pendant', throw: 'pendant', note: 'The bulb in the pendant is gimballed toward the wall, not at the table; it paints a misty lake with tomorrow, the 8:05 train and dinner along the base.' },
  { id: 'ceiling', label: 'Bedroom ceiling', sub: 'bulb · night', throw: 'lamp', note: 'The bedside bulb points up and slightly into the room: real constellations, the sleep arc, one dim line for the morning.' },
  { id: 'studio', label: 'Studio wall', sub: 'beam · morning', throw: 'mount', note: 'A ceiling-mounted beam 2.4 m out throws down onto the wall beside the desks; one gate waiting, one Review.' },
];

export function ProjectionGlow({ frame, view }) {
  const [glow, setGlow] = useState(true);
  useEffect(() => { if (view === 'glow' || view === 'glass') setGlow(view === 'glow'); }, [view]);
  const toggle = (
    <span className="as-toggle" role="group" aria-label="layout variant">
      <button type="button" className={glow ? 'on' : ''} onClick={() => setGlow(true)}>glow · projection</button>
      <button type="button" className={!glow ? 'on' : ''} onClick={() => setGlow(false)}>glass · panel</button>
    </span>
  );
  return (
    <Tabbed frame={frame} tabs={ROOMS} start={0} interval={4600} extra={toggle} h={585 + 190}>
      {(tab) => (
        <>
          <div style={pos(0, 0, 1040, 585)}>
            {{
              living: <EveningLayout glow={glow} />, dining: <DiningLayout glow={glow} />,
              ceiling: <NightCeiling glow={glow} />, studio: <StudioWall glow={glow} />,
            }[tab.id]}
          </div>
          <div style={pos(0, 599, 1040, 176)}><ThrowDiagram kind={tab.throw} /></div>
        </>
      )}
    </Tabbed>
  );
}

/* ---- schedule editor ------------------------------------------------------ */
const SLOTS = [
  ['Waking', '05:50', 0.243, 0.027, '#f5c76a', 'ceiling'], ['Morning', '06:30', 0.27, 0.105, '#14e0c8', '2-pane'],
  ['Working', '09:00', 0.375, 0.146, '#8b7cff', 'card grid'], ['Midday', '12:30', 0.521, 0.104, '#38bdf8', 'timeline'],
  ['Afternoon', '15:00', 0.625, 0.125, '#3ecf8e', 'household'], ['Evening', '18:00', 0.75, 0.187, '#f5a623', 'full-bleed'],
  ['Night', '22:30', 0.937, 0.063, '#9aa0a6', 'ceiling'],
];
const TEMPLATES = ['full-bleed', '2-pane', 'card grid', 'timeline', 'PiP'];

export function ScheduleEditor({ frame }) {
  return (
    <Tabbed frame={frame} tabs={[{ id: 'sched', label: 'Schedule', sub: 'home · kitchen panel + beam', note: 'Schedules are nQube-style rule sets the device or home server executes; agents propose, the household accepts. Suggestions never touch business surfaces.' }]} start={0}>
      {() => (
        <Frame kind="console" label="portal · schedules · home">
          <div className="as-topband">
            <strong>Schedule · Home</strong><span className="as-dim">kitchen panel · living beam · bedroom bulb</span>
            <span className="as-spacer" />
            <Chip tone="teal">agent suggestions on</Chip><Chip>presence · 3 rooms</Chip><Chip>offline cache 6.2 GB</Chip>
          </div>
          <div className="as-sched">
            <div className="as-sched-day">
              <span className="as-h">Day</span>
              <div className="as-daybar">
                {SLOTS.map(([n, t, s, w, c, tpl]) => <div key={n} className={`as-slot ${n === 'Morning' ? 'on' : ''}`} style={{ top: `${s * 100}%`, height: `${w * 100}%`, borderColor: c }}><strong>{n}</strong><span>{t} · {tpl}</span></div>)}
                {['00', '06', '12', '18', '24'].map((h, i) => <span key={h} className="as-daytick" style={{ top: `${i * 25}%` }}>{h}</span>)}
              </div>
            </div>
            <div className="as-sched-slot">
              <Card title="Morning · 06:30–09:00" right="kitchen panel · weekdays">
                <span className="as-h">Template</span>
                <div className="as-templates">{TEMPLATES.map((t) => <span key={t} className={`as-tpl ${t === '2-pane' ? 'on' : ''}`}><i className={`g-${t.replace(/\W/g, '')}`} />{t}</span>)}</div>
                <div className="as-row as-dim"><span>glass variant on the panel · glow variant auto-selected on the beam</span></div>
              </Card>
              <Card title="Rules" right="run locally · 5" className="wide">
                <Line a="Gate waiting" b="priority ≥ high → pull the card forward · agentOS review queue" c="on" tone="teal" />
                <Line a="Empty room 10 min" b="dim to the scene · 20% · wake on presence" c="on" tone="teal" />
                <Line a="Rain within 2 h" b="swap the commute card for shell + umbrella" c="on" tone="teal" />
                <Line a="Quiet hours" b="22:00–07:00 · no business cards on glass · gates wait for the phone" c="on" tone="teal" />
                <Line a="Guests" b="calendar says visitors → hide household and business boards" c="off" />
              </Card>
              <Card title="Triggers" right="3">
                <Line a="06:30" b="Mon–Fri · 08:00 Sat–Sun" c="time" />
                <Line a="Presence" b="kitchen · first person in" c="event" />
                <Line a="Mia's alarm" b="swim-kit note on Thursdays" c="event" />
              </Card>
              <Card title="Sources" right="6 · refresh 60 s">
                {[['Departures', 'local transit · open data'], ['Weather', 'met service · radar'], ['Calendar', '2 accounts · shared'], ['Family notes', 'household · local'], ['Pending gates', 'nventr · agentOS · read'], ['Athena', 'nventr · analytics · read']].map(([a, b]) => <Line key={a} lead={<span className="as-check on" />} a={a} b={b} />)}
              </Card>
            </div>
            <div className="as-sched-side">
              <Card title="Agent proposal" right="12 min ago" tone="violet">
                <strong className="as-prop-title">Tonight: coastal loop + quiet news</strong>
                <span className="as-h">Why</span>
                <Line a="calendar ends 18:30" b="no evening commitments" />
                <Line a="rain clears 17:00" b="west window catches the sunset" />
                <Line a="markets skipped" b="3 evenings in a row" />
                <span className="as-h">Changes</span>
                <Line a="Evening template" b="full-bleed · scene ocean-dusk" c="was forest" />
                <Line a="News filter" b="calm · local · outdoors" c="was markets" />
                <Line a="Music" b="Nils Frahm · quiet · 40%" c="new" />
                <div className="as-btnrow"><span className="as-btn primary">Accept tonight</span><span className="as-btn">Edit</span><span className="as-btn">Dismiss</span></div>
                <span className="as-dim">Personal ambient only · no system of record is touched · reversible</span>
              </Card>
              <Card title="Preview" right="next 4 slots">
                <div className="as-preview">{SLOTS.slice(1, 5).map(([n, t, , , c, tpl]) => <div key={n} style={{ borderColor: c }}><strong>{t}</strong><span>{n}</span><em>{tpl}</em></div>)}</div>
              </Card>
            </div>
          </div>
        </Frame>
      )}
    </Tabbed>
  );
}
